import { ManualJournalRecurringRuleSchema } from "@common/schemas/domains/accounting/manualJournalRecurringRule";
import { z } from "zod";

export enum ManualJournalRecurringUpdate {
    ALL = "all",
    FOLLOWING = "following",
    CURRENT = "current",
}

export type ManualJournalRecurringRule = z.infer<
    typeof ManualJournalRecurringRuleSchema
>;
